import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionService } from '../common/permission-service.service';

@Directive({
  selector: '[eoAnyPermission]',
})
export class EoAnyPermissionsDirective {
  @Input('eoAnyPermission') permissions!: string[];

  constructor(
    private tokenService: PermissionService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    const hasPermission = this.tokenService.hasPermission(
      this.permissions,
      'ANY'
    );

    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
